






















import { Component, Vue } from 'vue-property-decorator'
import { Alarm } from '../store/alarm'
import Add from './Add.vue'
import Edit from './Edit.vue'
import { namespace } from 'vuex-class'

const alarmStore = namespace('alarm')

@Component({ components: { Add, Edit } })
export default class MainAlarm extends Vue {
  @alarmStore.Action getAll!: () => void
  @alarmStore.Getter alarms!: Alarm[]
  created() {
    this.getAll()
  }
}
